import { createRouter, createWebHistory } from 'vue-router'
import { useStore } from 'vuex'; // Importa useStore

import DashboardView              from '../views/auth/DashboardView.vue'
// import ProfileView              from '@/views/ProfileView.vue'
// import PropertiesView           from '@/views/PropertiesView.vue'
// import CustomersView            from '@/views/CustomersView.vue'
import LoginView                  from '@/views/LoginView.vue'
import RestoreAccountView         from '@/views/RestoreAccountView.vue'
import InfoProfileView            from '@/views/auth/InfoProfileView.vue'
import InfoCompanyView            from '@/views/auth/InfoCompanyView.vue'
import ActiveAccountView         from '@/views/ActiveAccountView.vue'
import CreateAccountView from '@/views/CreateAccountView.vue';
import InfoNetworksView from '@/views/auth/InfoNetworksView.vue';
import PropertiesView from '@/views/auth/PropertiesView.vue';

import RegisterPhone from '@/views/RegisterPhone.vue';
import VerifyOTP from '@/components/VerifyOPT.vue';
import ChangePasswordView from '@/views/auth/ChangePasswordView.vue';
import PropertyFormView from '@/views/auth/properties/PropertyFormView.vue';
import PropertiesListView from '@/views/auth/properties/PropertiesListView.vue';
import LeadsListView from '@/views/auth/leads/LeadsListView.vue';
import RealStateExchangeView from '@/views/auth/exchange/RealStateExchangeView.vue';
import ExchangeListComponent from '@/components/exchange/ExchangeListComponent.vue';
import PropertyDetailComponent from '@/components/exchange/PropertyDetailComponent.vue';
import Step0Register from '@/components/onboarding/Step0Register.vue';
import Step1Register from '@/components/onboarding/Step1PersonalInfo.vue';
import Step2Register from '@/components/onboarding/Step2OTPVerification.vue';
import Step3Register from '@/components/onboarding/Step3Welcome.vue';
import UpdatePasswordView from '@/views/UpdatePasswordView.vue';
import CountriesList from '@/views/CountriesList.vue';
import SocialLogin from '@/views/SocialLogin.vue';
import VerifyAccount from '@/views/SocialLogin.vue';
//import OnboardingView from '@/views/OnboardingView.vue';
import MyPropertyDetail from '@/components/properties/MyPropertyDetailComponent.vue';
import HomeComponent from '@/components/Home/HomeComponent.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/country', component: CountriesList },
  { path: '/hoy', component: RegisterPhone },
  { path: '/verify', name: 'VerifyOTP', component: VerifyOTP },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path:'/update-profile-password/:token_temp?',
    name: 'update_profile_password',
    component: UpdatePasswordView
  },
  {
    path: '/create-account',
    name: 'create_account',
    component: CreateAccountView
  },
  {
    path: '/active_account/:token_temp',
    name: 'active_account',
    component: ActiveAccountView
  },  
  {
    path: '/forgot-password',
    name: 'forgot_password',
    component: RestoreAccountView
  },

  {
    path: '/restore_account/:token_temp',
    name: 'restore_account',
    component: RestoreAccountView
  },
  {
    path: '/info-profile',
    name: 'info_profile',
    component: InfoProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: '/info-company',
    name: 'info_company',
    component: InfoCompanyView,
    meta: { requiresAuth: true }
  },
  {
    path: '/info-networks',
    name: 'info_networks',
    component: InfoNetworksView,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-password',
    name: 'change_password',
    component: ChangePasswordView,
    meta: { requiresAuth: true }
  },
  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/properties',
    name: 'properties',
    component: PropertiesView,
    meta: { requiresAuth: true },
    children:[
      {
        path: '',
        name: 'propertyList',// properties/propertyList
        component: PropertiesListView,
        meta: { requiresAuth: true },
      },
      {
        path: 'form',
        name: 'propertyForm',
        component: PropertyFormView,
        meta: { requiresAuth: true },
      },
      {
        path: 'form/:id',
        name: 'propertyFormEdit',
        component: PropertyFormView,
        meta: { requiresAuth: true },
      },
      {
        path: '/properties/:property_id',
        name: 'my_property_detail',// properties/propertyList
        component: MyPropertyDetail,
        meta: { requiresAuth: true },
      }
    ]
  },

  {
    path: '/bolsa-inmobiliaria',
    name: 'real_state_exchange',
    component: RealStateExchangeView,
    meta: { requiresAuth: true },
    children:[
      {
        path: '',
        name: 'exchange_list',// properties/propertyList
        component: ExchangeListComponent,
        meta: { requiresAuth: true },
      },
      {
        path: '/propiedad/:property_id',
        name: 'property_detail',// properties/propertyList
        component: PropertyDetailComponent,
        meta: { requiresAuth: true },
      }
    ]
  },

  {
    path: '/customers',
    name: 'leads',
    component: LeadsListView,
    meta: { requiresAuth: true }    
  },
  {
    path: '/login_social',
    name: 'social-login',
    component: SocialLogin,
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: Step0Register
  },
  {
    path: '/onboarding/step1',
    name: 'step1',
    component: Step1Register
  },
  {
    path: '/onboarding/step2',
    name: 'step2',
    component: Step2Register
  },
  {
    path: '/onboarding/step3',
    name: 'step3',
    component: Step3Register
  },
  {
    path: '/login_social/:token',
    name: 'LoginSocial',
    component: VerifyAccount // o la vista que uses
  },
  {
    path: '/home',
    name: 'Home',
    component: HomeComponent,
    meta: { requiresAuth: true },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  if (to.meta.requiresAuth) {
    document.body.classList.remove('bg-dark_bg-100');
    document.body.classList.add('bg-black');
  } else {    
    document.body.classList.remove('bg-black');
    document.body.classList.add('bg-dark_bg-100');    
    document.body.classList.add('bg-dark_bg-100');    
  }
});

router.beforeEach((to, from, next) => {
  const store = useStore(); // Obtén la tienda Vuex
  const isAuthenticated = store.state.userSession; 

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
  } else if (to.path === '/login' && isAuthenticated) {
    console.log(isAuthenticated)
    //next('/dashboard'); // Redirige al dashboard si está autenticado y trata de acceder a login
    if (isAuthenticated['step'] == 0) {
      next('info-company');
      // next('info-profile');      
    }else if (isAuthenticated['step'] == 1) {
      //router.push({ name: "dashboard" });
      next('info-profile');      
      // next('info-company');
    }else if (isAuthenticated['step'] == 2) {
      //router.push({ name: "dashboard" });
      next('info-networks');      
    }else if (isAuthenticated['step'] == 3) {
      //router.push({ name: "dashboard" });      
      window.location.href = "/home";
    }
  } else {
    next();
  }

});
export default router
